import React from 'react';
import PropTypes from 'prop-types';
import {
  FDIcon, FDLabelText, FDPaper, FDStack,
} from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { getBorder } from 'Components/utils';
import { RoadmapExplorerGoalRow } from 'Components/UI/roadmapExplorer/goalsAccordion/row';
import { ProgressWithIcon } from 'Packages/FacetDesign/Components/Experimental/ProgressWithIcon';
import { RoadmapExplorerGoalAccordionLayout } from './goalAccordionLayout';
import { metaOverrideSet } from './metaOverrideSet';

const useStyles = buildUseStyles('RoadmapExplorerGoalsAccordion', (theme) => ({
  dividers: {
    '& > * + *': {
      ...getBorder(theme, { top: true }),
    },
  },
  invisible: {
    visibility: 'hidden',
  },
  awkwardSpacing: {
    paddingTop: theme.spacing(3),
  },
}));

export const RoadmapExplorerGoalsAccordion = ({ goals, condensed }) => {
  const classes = useStyles();
  if (goals.length === 0) {
    return null;
  }
  return (
    <FDPaper minWidth="700px">
      {condensed ? null : (
        <FDStack direction="row" paddingX={2} paddingY={1}>{/* Mimics the padding of an accordion */}
          <RoadmapExplorerGoalRow
            name={<FDLabelText color="textDisabled" value={goals[0].metaField('name').attr('prompt')} size="md" />}
            progress={<div className={classes.invisible}><ProgressWithIcon totalValue={0} color="Red" /></div>}
            goalAmount={<FDLabelText color="textDisabled" value={goals[0].metaField('goalAmount').attr('prompt')} size="md" />}
            goalDate={<FDLabelText color="textDisabled" value={goals[0].metaField('goalDate').attr('prompt')} size="md" />}
          />
          {/* Mimics the amount of space an accordion's dropdwon icon takes up */}
          <div className={classes.invisible}><FDStack paddingX={1}><FDIcon icon="arrowDropDown" /></FDStack></div>
        </FDStack>
      )}
      <div className={classes.dividers}>
        {goals.map(goal => (
          <MetaResourceRenderer
            key={goal.id()}
            resource={goal}
            metaOverrideSet={metaOverrideSet}
            layout={RoadmapExplorerGoalAccordionLayout}
            LayoutProps={{ condensed }}
          />
        ))}
        {condensed ? null : <div className={classes.awkwardSpacing} />}
      </div>
    </FDPaper>
  );
};
RoadmapExplorerGoalsAccordion.propTypes = {
  goals: PropTypes.arrayOf(PropTypes.object).isRequired,
  condensed: PropTypes.bool,
};
